import { useEffect } from "react";
import { Form } from "antd";
import { useAtom } from "jotai";
import { frmPreguntasComunicacionReportesAtom, puntajeTotalComunicacionReportesAtom } from "../../BandejaEvaluacionStorage";

const usePreguntasComunicacionReportes = () => {
	const [puntajeTotal, setPuntajeTotal] = useAtom(puntajeTotalComunicacionReportesAtom);
	const [frmPreguntas, setFrmPreguntas] = useAtom(frmPreguntasComunicacionReportesAtom);
	const [form] = Form.useForm();

	useEffect(() => {
		if (!frmPreguntas) {
			setFrmPreguntas(form);
		}
	}, []);

	return { frmPreguntas, puntajeTotal, setPuntajeTotal };
};

export default usePreguntasComunicacionReportes;
